import React from 'react'

import { Form, Col } from '_zari/core'

import * as SedeCrud from 'services/sede.service'

const IdSedeOrigenFormGroup = ({ value, onChange }) => {
  const [sedes, setSedes] = React.useState([])

  React.useEffect(() => {
    SedeCrud.obtenerExceptoActual().then(({ data }) => setSedes(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='ESTABLECIMIENTO ORIGEN' htmlFor='select-sedeOrigen' md={4} />
      <Col md={8}>
        <Form.Select name='selectSede' value={value} onChange={onChange} id='select-sedeOrigen'>
          <option value=''>Seleccionar</option>
          {sedes &&
            sedes.map((val, key) => (
              <option key={key} value={val._id}>
                {val.nombre}
              </option>
            ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdSedeOrigenFormGroup)
